import ConditionalOperators from "./conditionalOperators.service";

angular
  .module("acl.visualizer.conditionalOperators", ["acl.common.config", "acl.common.localize"])
  .service("ConditionalOperators", ConditionalOperators);
